import ActionCable from 'actioncable';

let cable = null;

export function useActionCable(consumerUrl) {
  if (!consumerUrl) {
    console.log('No consumer URL provided for ActionCable');
    return;
  }
  if (!cable) {
    try {
      cable = ActionCable.createConsumer(consumerUrl);
      console.log(`Attempting to connect to ActionCable at ${consumerUrl}`);
    } catch (error) {
      console.error(
        `Failed to create ActionCable consumer at ${consumerUrl}:`,
        error
      );
      throw new Error(
        `Unable to connect to ActionCable server at ${consumerUrl}. Please verify the URL and check if the WebSocket server is running.`
      );
    }
  }
  const subscribeToChannel = (channelName, callbacks) => {
    if (!channelName) {
      console.log('No channel name provided for ActionCable subscription');
      return;
    }
    try {
      console.log('Subscribing to channel:', channelName, cable);

      const channel = cable.subscriptions.create(
        { channel: channelName },
        {
          connected() {
            if (callbacks.connected) {
              callbacks.connected(channelName);
            }
          },
          received(data) {
            console.log(`Received data from ${channelName}:`, data);
            if (callbacks.received) {
              callbacks.received(data, channelName);
            }
          },
          disconnected() {
            if (callbacks.disconnected) {
              callbacks.disconnected(channelName);
            }
          },
          rejected() {
            if (callbacks.rejected) {
              callbacks.rejected(channelName);
            }
          },
        }
      );

      return channel;
    } catch (error) {
      console.error(
        `Failed to subscribe to ${channelName} at ${consumerUrl}:`,
        error
      );
      throw new Error(
        `Could not subscribe to ${channelName}. Please check the channel details and ensure the ActionCable server is reachable.`
      );
    }
  };
  const disconnectChannel = () => {
    if (!cable) {
      console.log('No ActionCable connection to disconnect');
      return;
    }
    cable.subscriptions.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    cable.disconnect();
    cable = null;
  };
  return {
    subscribeToChannel,
    disconnectChannel,
  };
}
